// API base URL resolution.
//
// Three contexts to satisfy:
//
//   - dev (`pnpm dev`): empty string so the Vite proxy at /api forwards
//     to localhost:1337. Branch on import.meta.env.DEV so a forgotten
//     VITE_API_URL doesn't accidentally point local testing at prod.
//
//   - prod under *.stemne.no on Cloudflare Pages: the SPA and the API
//     live on different subdomains; relative /api/... would 405 from
//     Pages. Use the absolute api.stemne.no host so the call lands on
//     the Stemne Caddy on Hetzner.
//
//   - VITE_API_URL escape hatch: explicit override wins. Useful for
//     preview builds, alternative API hosts, and integration tests.
function resolveApiBase(): string {
  if (import.meta.env.VITE_API_URL) return import.meta.env.VITE_API_URL as string
  if (import.meta.env.DEV) return ''
  return 'https://api.stemne.no'
}

export const API_BASE = resolveApiBase()

// toAbsoluteApiUrl resolves a possibly-relative API path against API_BASE so it
// can be opened as a top-level navigation (window.open) or fetched directly.
//
// The document preview endpoint returns two shapes: an absolute presigned S3
// URL for plaintext files, and a RELATIVE `/api/admin/documents/{id}/view`
// path for encrypted files (the cookie-authed decrypt stream). In production
// the SPA and API live on different subdomains, so a bare relative path would
// resolve against the SPA origin and 404 — prefix API_BASE to land it on the
// API host. Absolute URLs (presigned S3, or anything with a scheme) pass
// through untouched.
export function toAbsoluteApiUrl(url: string): string {
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith('/')) return `${API_BASE}${url}`
  return url
}
